export const LOAD_INDICADORES_PROCESSO = 'LOAD_INDICADORES_PROCESSO';
export const INDICADOR_PROCESSO_ERROR = 'INDICADOR_PROCESSO_ERROR';
export const INDICADORES_PROCESSO_DATA = 'INDICADORES_PROCESSO_DATA';
export const STORE_INDICADOR_PROCESSO = 'STORE_INDICADOR_PROCESSO';
export const GET_INDICADOR_PROCESSO = 'GET_INDICADOR_PROCESSO';
export const SHOW_INDICADOR_PROCESSO = 'SHOW_INDICADOR_PROCESSO';
export const REMOVER_INDICADOR_PROCESSO = 'REMOVER_INDICADOR_PROCESSO';
export const CHANGE_STATUS_CODE = 'CHANGE_STATUS_CODE';
